import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function LmsShortcut() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const showWelcome = new URLSearchParams(location.search).get('welcome') === '1';

  useEffect(() => {
    if (!user?.lmsActive) return;
    navigate('/student/dashboard', { replace: true });
  }, [user, navigate]);

  if (user?.lmsActive) {
    return (
      <div className="page-content" style={{ maxWidth: '720px', margin: '0 auto' }}>
        <div className="card" style={{ marginTop: '40px' }}>
          <div className="card-body" style={{ textAlign: 'center', padding: '48px' }}>
            <h1 style={{ fontSize: '1.75rem', marginBottom: '12px' }}>LMS Access Ready</h1>
            {showWelcome && (
              <div className="badge badge-success" style={{ marginBottom: '16px' }}>
                Welcome! Payment confirmed and portal access is active.
              </div>
            )}
            <p style={{ color: 'var(--gray-500)', marginBottom: '24px' }}>
              {user ? 'Your dashboard is ready.' : 'Sign in to continue to your dashboard.'}
            </p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/student/dashboard')}
              disabled={!user}
            >
              {user ? 'Go to Dashboard' : 'Sign in'}
            </button>
            {!user && (
              <button className="btn btn-outline" style={{ marginTop: '12px' }} onClick={() => navigate('/login')}>
                Go to Login
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content" style={{ maxWidth: '720px', margin: '0 auto' }}>
      <div className="card" style={{ marginTop: '40px' }}>
        <div className="card-body" style={{ textAlign: 'center', padding: '48px' }}>
          <h1 style={{ fontSize: '1.75rem', marginBottom: '12px' }}>Access Locked</h1>
          <p style={{ color: 'var(--gray-500)', marginBottom: '24px' }}>
            Access locked until admin approval is confirmed.
          </p>
          <button className="btn btn-primary" onClick={() => navigate('/student/registration')}>
            Complete Student Registration
          </button>
        </div>
      </div>
    </div>
  );
}
